import { useSettings } from "@/data/Settings";
import { ID } from "@/data/types/Basic";
import { ItnlIntegrationScript } from "@/data/types/ItnlIntegrationScript";
import { loadExternalScripts, removeScripts } from "@/utils/loadExternalScripts";
import { Paper } from "@mui/material";
import { FC, useEffect, useMemo } from "react";
import { bvSectionSx } from "./styles/bvsection";
import { waitForElement } from "@/utils/waitForElementToLoad";

export const PDPBazaarVoiceRv:FC<{id:ID}> = ({id}) => {
    const _id = id.toString();
    const {settings} = useSettings();
    const { bvClientName, bvSiteId, bvEnvironment, bvLocale } = useMemo(()=>settings.userData,[settings]);

    useEffect(()=>{
        if(id && bvClientName){
            const scripts:ItnlIntegrationScript[] = [
                {
                    id:"bazaar_voice_script",
                    retainScript:true,
                    skipIfExists:true,
                    url:`https://apps.bazaarvoice.com/deployments/${bvClientName}/${bvSiteId}/${bvEnvironment}/${bvLocale}/bv.js`,
                    onLoadScripts:[
                        {
                            scriptContent:`$BV.configure('global', { productId : ${_id} });`,
                            id:'bazaar_voice_onload_script'
                        }
                    ]
                }
            ]
            loadExternalScripts(scripts);
            return(()=>removeScripts(scripts))
        }
    },[_id, bvClientName]);

    useEffect(() => {
        const writeReviewsToproductData = () => {
            const productData = document.getElementById("productData") as HTMLElement;
            const bvAggRatingData = document.querySelector("#bv-jsonld-aggregate-rating-data") as HTMLElement | null;
            const bvReviewsData = document.querySelector('#bv-jsonld-reviews-data') as HTMLElement | null;
            if(productData){
                const productDataObj = JSON.parse(productData?.innerText??"");
                if(bvAggRatingData)productDataObj.aggregateRating = JSON.parse(bvAggRatingData?.innerText??"{}")?.aggregateRating;
                if(bvReviewsData)productDataObj.review = JSON.parse(bvReviewsData?.innerText??"[]")?.review;
                productData.innerText = JSON.stringify(productDataObj);
                if(bvAggRatingData)document.head.removeChild(bvAggRatingData);
                if(bvReviewsData)document.head.removeChild(bvReviewsData);
            }
        }
        waitForElement('#bv-jsonld-aggregate-rating-data', 3000, "head").then(function () {
            waitForElement('#productData', 3000, "productImageGrid").then(function () {
                setTimeout(()=>writeReviewsToproductData(),2000); //on page/path chnages, bv script injects old data and then add new data after validation time, add 2 secs of wait time for bv js validations.
            }).catch(() => {
                console.debug("Element productData did not load in 5 seconds");
            });
        }).catch(() => {
            console.debug("Element bv-jsonld-aggregate-rating-data did not load in 5 seconds")
        });
    }, [_id]);
    
    return(
        <Paper id="BVRR_Container" data-bv-show="reviews" data-bv-product-id={`${_id}`} sx={bvSectionSx} elevation={1}></Paper>
    );
}